import {
  BrowseViewResponseDto,
  ApiError,
  ErrorResponseDto,
  BrowseViewState,
} from '@pro4-erp/core-web';
import { AuditorVisit } from '../types';
import env from '@/env';

type BrowseViewStateWithLang = BrowseViewState & { lang?: string };

export const getAuditorVisitsForMeFinished = async ({
  page,
  pageSize,
  search,
  sortBy,
  lang = '',
}: BrowseViewStateWithLang): Promise<BrowseViewResponseDto<AuditorVisit>> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-visits/me/finished?${new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      search: search.toString(),
      sortBy: sortBy ? JSON.stringify(sortBy) : '',
      lang,
    })}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as BrowseViewResponseDto<AuditorVisit>;
  return response;
};
